import React, { Component } from "react";
import { DotLoader } from "react-spinners";
import { connect } from "react-redux";
import axios from "axios";
import "../../components/tabsApps/style/style.css";
import { NotificationsIcon } from "../../lib/icons";
import { createNotification, getNotifications, deleteNotifications, clearNotifications } from "./notificationsReducer";
import { getSlides } from "../../components/pptCart/pptCartReducer";
import "../../components/profile/style/style.css";
import "./style.css";
import { socket } from "../../routes";
import { NotificationsItem } from "../../components/notifications/notificationsItem";
import withOutsideClick from "../../hocs/withOutsideClick";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listOpen: false,
    };

    this.socketListenerRegistered = false;
    this.progressPollInterval = null;
    this.deleteAllHandler = this.deleteAllHandler.bind(this);
    this.downloadActionHandler = this.downloadActionHandler.bind(this);
    this.toggleList = this.toggleList.bind(this);
    this.displayBadges = this.displayBadges.bind(this);
    this.checkForIframeClick = this.checkForIframeClick.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentWillUnmount() {
    // Add safety check
    if (socket) {
      socket.off("DownloadAction", this.downloadActionHandler);
    }
    window.removeEventListener("blur", this.checkForIframeClick, false);
    this.stopProgressPolling();
  }

  componentDidMount() {
    // Register socket listener with retry pattern
    this.registerSocketListener();
    window.addEventListener("blur", this.checkForIframeClick, false);
  }

  registerSocketListener() {
    if (socket && !this.socketListenerRegistered) {
      socket.on("DownloadAction", this.downloadActionHandler);
      this.socketListenerRegistered = true;
    }
  }

  startProgressPolling() {
    if (this.progressPollInterval) return;
    this.progressPollInterval = setInterval(() => {
      const terminalStatuses = ["complete", "error", "failed"];
      const hasRunning = this.props.notifications.some((n) => !terminalStatuses.includes(n.status));
      if (hasRunning) {
        this.props.getNotifications();
      } else {
        this.stopProgressPolling();
      }
    }, 3000);
  }

  stopProgressPolling() {
    if (this.progressPollInterval) {
      clearInterval(this.progressPollInterval);
      this.progressPollInterval = null;
    }
  }

  checkForIframeClick = (event) => {
    if (document.activeElement.tagName === "IFRAME") {
      this.setState({
        listOpen: false,
      });
    }
  };

  async downloadActionHandler(action) {
    // Refresh notifications immediately
    this.props.getNotifications();
    // Add delay to ensure the backend has finished saving the slide before fetching
    setTimeout(() => {
      this.props.getSlides(true); // Force refresh to update the PPT cart
    }, 500);
  }

  componentDidUpdate() {
    const { apps, loaded } = this.props;
    if (apps.length > 0 && !loaded) {
      this.props.getNotifications();
    }
    // Retry registering socket listener if it wasn't available on mount
    if (!this.socketListenerRegistered) {
      this.registerSocketListener();
    }
  }

  handleClickOutside() {
    if (this.state.listOpen) {
      this.props.clearNotifications();
      this.setState({
        listOpen: false,
      });
    }
  }

  deleteAllHandler() {
    axios
      .post(
        `${process.env.REACT_APP_BIGHORN_SERVER}/api/app/removeAllNotifcations`,
        {},
        {
          headers: {
            ClientToken: localStorage.getItem("clientToken"),
          },
        },
      )
      .then((response) => {
        this.props.getNotifications();
      })
      .catch((error) => {});
  }

  toggleList() {
    const { listOpen } = this.state;
    if (listOpen) {
      this.props.clearNotifications();
      this.stopProgressPolling();
    }
    this.setState(
      (prevState) => ({
        listOpen: !prevState.listOpen,
      }),
      () => {
        if (this.state.listOpen) {
          this.props.getNotifications();
          this.startProgressPolling();
        }
      },
    );
  }

  renderNotificationsItem(notifications) {
    return notifications.map((item, index) => {
      return <NotificationsItem item={item} key={index} index={index} onChange={this.props.getNotifications} />;
    });
  }

  displayBadges() {
    const { notifications, count, unviewedCount } = this.props;
    const hasProcessingJob = notifications.some((item) => {
      return item.status !== "complete" && item.status !== "error" && item.status !== "failed";
    });

    const renderPlain = () => (
      <OverlayTrigger placement={"left"} overlay={<Tooltip id={"notifications-tooltip"}>View Notifications</Tooltip>}>
        <div className="notifications" onClick={() => this.toggleList()}>
          <NotificationsIcon color={"rgba(88, 89, 91, 1)"} height={"20"} className="notifications-icon" />
        </div>
      </OverlayTrigger>
    );

    const renderBadge = (value) => (
      <OverlayTrigger placement={"left"} overlay={<Tooltip id={"notifications-tooltip"}>View Notifications</Tooltip>}>
        <div className="notifications notifications-with-count" onClick={() => this.toggleList()}>
          <NotificationsIcon color={"rgba(88, 89, 91, 1)"} height={"20"} className="notifications-icon" />
          <span className="notifications-badge">{value}</span>
        </div>
      </OverlayTrigger>
    );

    const renderSpinner = () => (
      <OverlayTrigger placement={"left"} overlay={<Tooltip id={"notifications-tooltip"}>View Notifications</Tooltip>}>
        <div className="notifications notifications-with-spinner" onClick={() => this.toggleList()}>
          <NotificationsIcon color={"rgba(88, 89, 91, 1)"} height={"20"} className="notifications-icon" />
          <span
            style={{
              position: "absolute",
              top: "-6px",
              left: "10px",
            }}>
            <DotLoader size={15} color={"#CC7E00"} loading={true} />
          </span>
        </div>
      </OverlayTrigger>
    );

    if (count > 0 && hasProcessingJob) {
      return renderSpinner();
    }
    if (count > 0 && unviewedCount > 0) {
      return renderBadge(unviewedCount);
    }
    return renderPlain();
  }

  render() {
    const { notifications } = this.props;

    return (
      <div className={"flex-container"}>
        <div className="notifications-parent">
          {this.state.listOpen ? (
            <div style={{ height: "100%", width: "100%", marginTop: "4px" }}>
              <div className="notifications-selected" onClick={() => this.toggleList()}>
                <NotificationsIcon color={"white"} height={"20"} className="notifications-icon-selected notifications-icon" />
              </div>
              <div style={{ position: "absolute" }}>
                <div className="notifications-dd-items">
                  <div className="notifications-title-container">
                    <div className="notifications-title">Notifications</div>
                    <div className="clear-all" onClick={this.deleteAllHandler}>
                      clear all
                    </div>
                  </div>
                  <hr />
                  <div className="notification-message-div">{this.renderNotificationsItem(notifications)}</div>
                </div>
              </div>
            </div>
          ) : (
            <div>{this.displayBadges()}</div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  notifications: state.notifications.notifications,
  count: state.notifications.count,
  unviewedCount: state.notifications.unviewedCount,
  apps: state.app.apps,
  loading: state.notifications.loading,
  isAuthed: state.auth.isAuthed,
  loaded: state.notifications.loaded,
});

const mapDispatchToProps = (dispatch) => ({
  createNotification(notification) {
    dispatch(createNotification(notification));
  },
  getNotifications() {
    dispatch(getNotifications());
  },
  deleteNotifications(slides, item = null) {
    dispatch(deleteNotifications(slides, item));
  },
  getSlides(forceRefresh = false) {
    dispatch(getSlides(forceRefresh));
  },
  clearNotifications() {
    dispatch(clearNotifications());
  },
});

const NotificationsWithOutsideClick = withOutsideClick(Notifications);
export default connect(mapStateToProps, mapDispatchToProps)(NotificationsWithOutsideClick);
